var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.001,
    height: 24,
    viewBox: "0 0 24.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 24,
    height: 24,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    transform: "translate(-492 -422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_Smart_Object-2",
    "data-name": "Vector Smart Object",
    transform: "translate(492 422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M21,4.1V3.075A3.042,3.042,0,0,0,18,0H3A3.042,3.042,0,0,0,0,3.075v10.25A3.042,3.042,0,0,0,3,16.4H4V21.95L9.414,16.4H10V14.35H8.586L6,17V14.35H3a1.014,1.014,0,0,1-1-1.025V3.075A1.014,1.014,0,0,1,3,2.05H18a1.014,1.014,0,0,1,1,1.025V4.1Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M21,5.125H14A3.042,3.042,0,0,0,11,8.2v8.2a3.042,3.042,0,0,0,3,3.075h2.586L21,24V19.475A3.042,3.042,0,0,0,24,16.4V8.2a3.042,3.042,0,0,0-3-3.075M22,16.4a1.014,1.014,0,0,1-1,1.025H19v1.626l-1.586-1.626H14A1.014,1.014,0,0,1,13,16.4V8.2a1.014,1.014,0,0,1,1-1.025h7A1.014,1.014,0,0,1,22,8.2Z",
    fill: "#757575"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M508.586,441.475H506a3.042,3.042,0,0,1-3-3.074v-8.2a3.042,3.042,0,0,1,3-3.074h7a3.042,3.042,0,0,1,3,3.074v8.2a3.042,3.042,0,0,1-3,3.074V446ZM505,430.2v8.2a1.014,1.014,0,0,0,1,1.025h3.414L511,441.051v-1.625h2a1.014,1.014,0,0,0,1-1.025v-8.2a1.014,1.014,0,0,0-1-1.025h-7A1.014,1.014,0,0,0,505,430.2Zm-9,8.2h-1a3.042,3.042,0,0,1-3-3.075v-10.25A3.042,3.042,0,0,1,495,422h15a3.042,3.042,0,0,1,3,3.075V426.1h-2v-1.025a1.014,1.014,0,0,0-1-1.025H495a1.014,1.014,0,0,0-1,1.025v10.25a1.014,1.014,0,0,0,1,1.025h3V439l2.586-2.65H502v2.05h-.586L496,443.95Z",
    fill: "#12d6df"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.01c4bcfac50fa44794cfedd0c8e0f00b.svg";
export { ForwardRef as ReactComponent };